import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiscModule } from 'projects/core/src/public-api';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ContactInfoComponent } from './view/customer-window/contact-info/contact-info.component';
import { CustomerWindowComponent } from './view/customer-window/customer-window.component';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {FilesMiscModule} from '../files-misc/files-misc.module';
import {InputSwitchModule} from 'primeng/inputswitch';

@NgModule({
    declarations: [
        ContactInfoComponent,
        CustomerWindowComponent

    ],
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatProgressBarModule,
        SelectButtonModule,
        OverlayPanelModule,
        CalendarModule,
        FileUploadModule,
        MatIconModule,
        MatProgressSpinnerModule,
        AccordionModule,
        MiscModule,
        InputMaskModule,
        AutoCompleteModule,
        CheckboxModule,
        ConfirmDialogModule,
        TooltipModule,
        FilesMiscModule,
        InputSwitchModule
    ],
    exports: [
        ContactInfoComponent,
        CustomerWindowComponent
    ],
    entryComponents: [
        CustomerWindowComponent
    ]

})
export class CustomerMiscModule { }
